import React from 'react';
import s from './FinancialCalculators.scss';
import CalculatorCard from '../../mobile/CalculatorCard/CalculatorCard';

const FinancialCalculators = ({ items, name }) => {
  const gaCategory = `WEB-CL-finance-calculator_${name.split(' ')[0]}`;
  return (
    <>
      {/* <h1>{name}</h1> */}
      <div className={s.other_calc_container}>
        <div className={`${s.other_calc_wrap} financial_calc_wrap`}>
          {items.map(item => (
            <div className={s.card_container}>
              <CalculatorCard {...item} gaCategory={gaCategory} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FinancialCalculators;
